import script from "./PlaqueReportPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaqueReportPreview.vue?vue&type=script&setup=true&lang=ts"

import "./PlaqueReportPreview.vue?vue&type=style&index=0&id=63433d10&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63433d10"]])

export default __exports__